import { Archive, Plus } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Alert } from '@/components/ui/Alert';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import { ModuleTogglePanel } from '@/components/dashboard/ModuleTogglePanel';

export function BackupsPage() {
  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-h1 text-text-primary mb-1">Backups</h1>
        <p className="text-small text-text-secondary">Configuration and structural server backups.</p>
      </div>

      <ModuleTogglePanel module="backup" title="Backups" permissionNote="Administrator permission required." />

      <Alert
        tone="warning"
        title="Restore is intentionally not available from the web"
        description="A structural (v2) restore wipes and rebuilds your server. That action stays Discord-command-only until a dedicated confirmation-flow design review happens — see docs/ARCHITECTURE.md §3.6. Listing, creating, and deleting individual backups also isn't connected yet — that needs Bridge endpoints beyond this pass's enable/disable toggle above."
      />

      <Card>
        <CardHeader title="Your backups" action={<Button variant="primary" size="sm" disabled><Plus size={14} aria-hidden="true" />Create backup</Button>} />
        <EmptyState icon={Archive} title="No backups to show yet" description="Backup listing isn't connected yet." />
      </Card>
    </div>
  );
}
